import Idap from '@finance/idap';
import { Env, IdapConfig } from '@finance/idap/es/lib/types';
import { trackBIEvent } from '@shopee/web-bridge-sdk';
import { getAppType } from './device';

// https://confluence.shopee.io/pages/viewpage.action?pageId=2197467064
const businessId = '1015';

export async function initIDAP() {
  if (REACT_APP_ENV === 'mock') {
    return;
  }

  try {
    const config: IdapConfig = {
      business_id: businessId,
      app_name: 'fastescrow',
      bridgeCall: (_, data: any) => trackBIEvent(data),
      api_auto_report: true,
      api_response_code: {
        key: 'code',
        code: [0],
      },
      country: BIZ_COUNTRY,
      env: REACT_APP_ENV as Env,
      user_id: Number(localStorage.getItem('platform_user_id')) || 0,
      api_path: /\/api\/(usercenter|fast-escrow)/,
      debug: true,
      log_report_level: 'warn',
    };
    // window.idapSDK = idapSDK;
    const idap = new Idap(config);
    window.idap = idap;
    console.log('init idap success');
  } catch (error) {
    console.log('init idap failed');
  }
}

// todo: finish user action
export namespace UserActions {
  export enum Home {
    ClickEnable = 'home.click_enable', // 开
    ClickDisable = 'home.click_disable', // 关
    ClickSetting = 'home.click_setting', // 设置
    ClickPayNow = 'home.click_pay_now', // 即将到账
    ClickUpcoming = 'home.click_upcoming', // 即将到账
    ClickOutstanding = 'home.click_outstanding', // 待还款
    ClickLimitAdjust = 'home.click_limit_Adjust', // 待还款
    ClickHistory = 'home.click_history', // 历史账单
  }

  export enum Repayment {
    ClickPay = 'repayment.click_pay', // 点击还款按钮，触发trigger repayment
    ClickPaymentOption = 'repayment.click_payment_option', // 点击还款方式
    CallTriggerRepayment = 'repayment.call_trigger_repayment', // 调用还款
    CallTriggerRepaymentResponse = 'repayment.call_trigger_repayment_response', // 调用还款的返回
    CallInvalidRepayUrl = 'repayment.call_invalid_repay_url',
    CallSpmCashierLaunch = 'repayment.call_spm_cashier_launch', // 调用SPM收银台
    CallSpmCashierLaunchResponse = 'repayment.call_spm_cashier_launch_response', // 调用SPM收银台的返回
  }

  export enum ThirdSdk {
    CallPaymentSelectionSDK = 'third_sdk.call_payment_selection_sdk',
    CallPaymentSelectionSDKResponse = 'third_sdk.call_payment_selection_sdk_response',
    CallPaymentSelectionSDKError = 'third_sdk.call_payment_selection_sdk_error',
  }

  export enum CommonProcesses {
    CallLogin = 'common_processes.call_login',
    CallAPIFail = 'common_processes.call_api_fail',
    CallAuthCodeErrResponse = 'common_processes.call_auth_code_err_response',
    CallNonceCodeErrResponse = 'common_processes.call_nonce_code_err_response',
    CatchWithErrorBoundary = 'common_processes.catch_with_error_boundary',
    CallPresignedUrl = 'common_processes.call_presigned_url',
    CallPresignedUrlError = 'common_processes.call_presigned_url_error',
  }

  export enum Setting {
    ClickProfile = 'setting.click_profile',
    ClickDisbursementPercentage = 'setting.click_disbursement_percentage',
    ClickContracts = 'setting.click_contracts',
    ClickEInvoiceSetting = 'setting.click_e_invoice_setting',
    ClickMarking = 'setting.click_marking',
  }
}

export type UserActionKeys =
  | UserActions.Home
  | UserActions.Repayment
  | UserActions.ThirdSdk
  | UserActions.CommonProcesses
  | UserActions.Setting;

export function sendUserAction(eventKey: UserActionKeys, data?: Record<string, any>) {
  try {
    const extra = data ? JSON.stringify(data) : '';
    const reportData: Record<string, any> = {
      event_key: eventKey,
      extra,
      app_type: getAppType(),
    };
    if (window.idap?.custom) {
      window.idap.custom('USER_ACTIONS', reportData);
      return;
    }
    // 使用console拦截来做兜底
    console.warn('USER_ACTIONS', reportData);
  } catch (e) {}
}
